<template>
	<div class="row">
	<div class="panel panel-primary">
		<div class="panel-heading">Add New Record</div>
		<div class="panel-body">
		<div class="form-group row">
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
				<label>Event</label>
				<event-select v-model="clubRecord.event_id"></event-select>
                <span v-if="errors['club_record.event_id']" :class="['label label-danger']">{{ errors['club_record.event_id'][0] }}</span>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
				<label>Course</label>
				<course-select v-model="clubRecord.course"></course-select>
                <span v-if="errors['club_record.course']" :class="['label label-danger']">{{ errors['club_record.course'][0] }}</span>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
				<label>Age Group</label>
				<age-group-select v-model="clubRecord.age_group_id"></age-group-select>
                <span v-if="errors['club_record.age_group_id']" :class="['label label-danger']">{{ errors['club_record.age_group_id'][0] }}</span>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
				<label>Gender</label>
				<gender-select v-model="clubRecord.gender"></gender-select>
                <span v-if="errors['club_record.gender']" :class="['label label-danger']">{{ errors['club_record.gender'][0] }}</span>
			</div>
		</div>
		<div class="form-group row">
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
				<label>First Name</label>
				<input class="form-control" v-model="clubRecord.first_name" placeholder="First Name" />
                <span v-if="errors['club_record.first_name']" :class="['label label-danger']">{{ errors['club_record.first_name'][0] }}</span>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
				<label>Last Name</label>
				<input class="form-control" v-model="clubRecord.last_name" placeholder="Last Name" />
                <span v-if="errors['club_record.last_name']" :class="['label label-danger']">{{ errors['club_record.last_name'][0] }}</span>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
				<label>Swim Date</label>
                <datepicker2 v-model="clubRecord.swim_date" inputClasses="" valueFormat="dd/mm/yyyy" displayFormat="dd/mm/yyyy" placeholder="Swim Date"/>
                <span v-if="errors['club_record.swim_date']" :class="['label label-danger']">{{ errors['club_record.swim_date'][0] }}</span>
			</div>
			<div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
				<label>Time</label>
				<input class="form-control" v-model="clubRecord.swim_time" placeholder="MM:SS.hh" />
                <span v-if="errors['club_record.swim_time']" :class="['label label-danger']">{{ errors['club_record.swim_time'][0] }}</span>
			</div>
		</div>
	</div>
	<div class="panel-footer">
		<button v-on:click="addNewRecord" class="btn btn-success pull-right">Save New Record</button>
		<div class="clearfix"></div>
	</div>
</div>
	</div>
</div>
</template>

<style scoped>

</style>

<script>

	export default {
		data: function () {
				return {
					clubRecord: {
						age_group_id: null,
						gender: null,
						event_id: null,
						course: null,
						first_name: '',
						last_name: '',
						swim_date: new Date().toLocaleString('en-GB', { timeZone: 'UTC' }),
						swim_time: ''
					},
                    errors: []
				}
		},
		computed: {

		},
		mounted() {
				console.log('Create Club Record component mounted.');
		},
		methods: {
			addNewRecord() {
				console.log('addNewRecord called');
				// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
				axios.post('/api/v1/club_record', {
					club_record: this.clubRecord
				}).then((response) => {
					// this.loadingInstance.close();
					console.log(response.data);
					this.resetForm();
					window.eventBus.$emit('add-new-club-record');
				}).catch((error) => {
					// this.loadingInstance.close();
                    console.log(error.response.data);
                    this.errors = error.response.data.errors;
					this.$message({message: 'There was a problem saving the record. Please check errors below.', type: 'error'});
				});
			},
			resetForm() {
				this.clubRecord.swim_date = null;
				this.clubRecord.swim_time = null;
				this.clubRecord.first_name = null;
				this.clubRecord.last_name = null;
			}
		}
	}
</script>